import BaseModel from './BaseModel'
import EventInventoryTier from './EventInventoryTier'
import { Inventory } from './Inventory'

/**
 * @todo Add types for API methods.
 */
export class EventTier extends BaseModel {

  static entity = 'event_tiers'
  static primaryKey = 'ID'

  declare ID: number
  declare inventoryID: number
  declare tierPrice: number
  declare tierInventoryPercentage: number
  declare inventory: Inventory
  declare eventInventoryTiers: EventInventoryTier

  static fields() {

    return {

      // fields
      ID: this.number(null),
      inventoryID: this.number(null),
      tierPrice: this.number(null),
      tierInventoryPercentage: this.number(null),      

      // relationships
      inventory: this.belongsTo(Inventory, 'inventoryID'),
      eventInventoryTiers: this.hasMany(EventInventoryTier, 'currentEventTierID'),

    }

  }

  /**
   * API methods
   */

  static mutate(payload: MutateEventTiersRequest) {

    return this.api().put('/venues/event_tiers', payload, {
      dataKey: 'upserted',
      dataTransformer: ({ data }) => {
        // remove deleted items from the store
        data.deleted.forEach((deletedEventTierID: number) => {
          this.delete(deletedEventTierID)
        })
        return data.upserted
      },
    })

  }

}

export interface MutateEventTiersRequest {
  operations: {
    inventory_id: number
    tiers: {
      price: number
      inventory_percentage: number // between 0 and 1
    }[]
  }[]
}
